import type { ApiClient } from './ApiClient';

// Forme alignée sur POST /parents/profile (PAR-01, apps/api/src/routes/parents.ts).
export interface CreateParentProfilePayload {
  phone: string;
}

export interface CreateParentProfileResponse {
  id: string;
  phone: string;
}

export function createParentProfile(
  client: ApiClient,
  payload: CreateParentProfilePayload,
  accessToken: string,
): Promise<CreateParentProfileResponse> {
  return client.post<CreateParentProfileResponse>('/parents/profile', payload, { accessToken });
}
